export const meetingTypes = [
    "In-person",
    "Whatsapp",
    "Text messages",
    "Email",
    "Online meeting (Zoom)",
    "Other",
  ];